import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Shikar2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data   => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/1.webp`;
    const p2  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/2.webp`;
    const p3  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/3.webp`;
    const p4  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/5a.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/6.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/7.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/8.webp`;
    const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/9.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/10.webp`;
    const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/11.webp`;
    const p13 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/12.webp`;
    const p14 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/13.webp`;
    const p15 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/14.webp`;
    const p16 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/15.webp`;
    const p17 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/16.webp`;
    const p18 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/17.webp`;
    const p19 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/18.webp`;
    const p20 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/19.webp`;
    const p21 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/20.webp`;
    const p22 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/21.webp`;
    const p23 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/22.webp`;
    const p24 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/23.webp`;
    const p25 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/24.webp`;
    const p26 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/25.webp`;
    const p27 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/26.webp`;
    const p28 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/27.webp`;
    const p29 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/28.webp`;
    const p30 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/29.webp`;
    const p31 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/30.webp`;
    const p32 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/31.webp`;
    const p33 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/32.webp`;
    const p34 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/33.webp`;
    const p35 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/34.webp`;
    const p36 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/35.webp`;
    const p37 = `${config.base_image_url_2025}/home/events-activities/school-programs/SHIKAR2025/36.webp`;

    const photos = [
        {
        src: p1,
        source: p1,
        rows: 1,
        cols: 1,
        },
        {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
        },
        {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
        }, 
        {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
        },
        {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
        },
        {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
        },
        {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
        },
        {
        src: p7,
        source: p7,
        rows: 1,
        cols: 1,
        },
        {
        src: p8,
        source: p8,
        rows: 1,
        cols: 1,
        },
        {
        src: p9,
        source: p9,
        rows: 1,
        cols: 1,
        },
        {
        src: p10,
        source: p10,
        rows: 1,
        cols: 1,
        },
        {
        src: p11,
        source: p11,
        rows: 1,
        cols: 1,
        },
        {
        src: p12,
        source: p12,
        rows: 1,
        cols: 1,
        },
        {
        src: p13,
        source: p13,
        rows: 1,
        cols: 1,
        },
        {
        src: p14,
        source: p14,
        rows: 1,
        cols: 1,
        },
        {
        src: p15,
        source: p15,
        rows: 1,
        cols: 1,
        },
        {
        src: p16,
        source: p16,
        rows: 1,
        cols: 1,
        },
        {
        src: p17,
        source: p17,
        rows: 1,
        cols: 1,
        },
        {
        src: p18,
        source: p18,
        rows: 1,
        cols: 1,
        },
        {
        src: p19,
        source: p19,
        rows: 1,
        cols: 1,
        },
        {
        src: p20,
        source: p20,
        rows: 1,
        cols: 1,
        },
        {
        src: p21,
        source: p21,
        rows: 1,
        cols: 1,
        },
        {
        src: p22,
        source: p22,
        rows: 1,
        cols: 1,
        },
        {
        src: p23,
        source: p23,
        rows: 1,
        cols: 1,
        },
        {
        src: p24,
        source: p24,
        rows: 1,
        cols: 1,
        },
        {
        src: p25,
        source: p25,
        rows: 1,
        cols: 1,
        },
        {
        src: p26,
        source: p26,
        rows: 1,
        cols: 1,
        },
        {
        src: p27,
        source: p27,
        rows: 1,
        cols: 1,
        },
        {
        src: p28,
        source: p28,
        rows: 1,
        cols: 1,
        },
        {
        src: p29,
        source: p29,
        rows: 1,
        cols: 1,
        },
        {
        src: p30,
        source: p30,
        rows: 1,
        cols: 1,
        },
        {
        src: p31,
        source: p31,
        rows: 1,
        cols: 1,
        },
        {
        src: p32,
        source: p32,
        rows: 1,
        cols: 1,
        },
        {
        src: p33,
        source: p33,
        rows: 1,
        cols: 1,
        },
        {
        src: p34,
        source: p34,
        rows: 1,
        cols: 1,
        },
        {
        src: p35,
        source: p35,
        rows: 1,
        cols: 1,
        },
        {
        src: p36,
        source: p36,
        rows: 1,
        cols: 1,
        },
        {
        src: p37,
        source: p37,
        rows: 1,
        cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                              SHIKHAR 2025-26
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />  Date: 28 and Saturday 29 November 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                               NPS Yeshwanthpur hosted its grand two-day triennial Sports Day celebration, SHIKHAR, filled with colour, energy and spirited participation from students across all grades on Friday 28 and Saturday 29 November 2025. It was graced by Dr Shivshanker, (Chairman NPS Yeshwanthpur), Dr Majula Shivshanker (Director), Ms Sheeja Manoj(Principal), Ms Sejuthi Shivshanker (Joint Secretary), Dr Sanjana Shivshanker (Trustee) and parents.
                                <br></br>

                                <b> Day 1: Senior Shikhar (Classes 6-12)</b> 
                                <br></br>
                                Day 1 marked the Shikhar events for students of Classes 6 to 12. A general welcome was accorded by Ms Sejuthi Shivshankar, which was followed by the ceremonial lighting of the lamp accompanied by an invocation song. Dr Sanjana Shivshanker represented the voice of the management, imploring that the screen time of our children must be limited and that they should be encouraged to engage in physical activity.
                                <br></br>

                                This was followed by the felicitation of the academic achievers of Class 12 Board Examination 2025 and achievers in the sports arena. A significant and heartfelt moment was when the school formally acknowledged the teachers and support staff who completed ten years of dedicated service at NPS Yeshwanthpur, appreciating their unwavering commitment and contributions.
                                <br></br>

                                The school was honoured to welcome Smt Uma Mahadevan, Additional Chief Secretary and Development Commissioner, Government of Karnataka, as the Chief Guest. In her keynote address, she inspired the gathering by urging students to look beyond themselves and give back to society—whether by offering their time at an NGO, donating books through school clubs or volunteering to teach in slums.
                               <br></br>

                               The Principal, Ms Sheeja Manoj, then presented the Annual Report, showcasing the school’s accomplishments in academics, sports and holistic development over the year. She warmly acknowledged the dedication of the school achievers and officially declared the event open.
                               <br></br>

                               This was followed by a spectacular march-past by the four houses, led by the school band. The contingents marched with precision, discipline and perfect coordination, setting an inspiring tone for the day. The oath of sportsmanship was then rendered by the Sports Captain of the school. The day further progressed with the lighting of the torch, a moment filled with pride and symbolism. The torch bearers were students who had achieved laurels at the CBSE clusters, state or national levels in various sporting events, representing the spirit of excellence that SHIKHAR upholds.
                               <br></br>
                              
                              Then we moved on to the star attraction of the day with students showcasing a vibrant array of drills, formations, and thematic displays that blended music, energy, and movement to create a lively rhythm on the field. Day 1 began with a Yoga performance, highlighting calmness, focus and inner balance, setting a serene tone for the day. Among the highlights was a unique Chess drill, both energetic and imaginative, where students brought the strategy and intensity of the game to life through perfectly coordinated formations.
                              <br></br>

                              Other drills—such as the Basketball drill, Taekwondo display, Resistance band drill, Aerobics drill and Lezim drill—highlighted the distinct skills required for each sport. Their precision and enthusiasm reflected hours of dedication and practice.
                              <br></br>
                              
                              There were also flower drills, ball drills and formation drills, each testing coordination, teamwork and aesthetic presentation. The field bloomed with colour and synchronised movement as students worked together to create memorable patterns and shapes.
                              <br></br>

                              The crowning highlight of the event was the Poi and wing drill, a stunning finale that combined grace, rhythm and the skill of rotating Poi balls in intricate formations. With beauty, style and fluid motion, it left the audience captivated.
                              <br></br>

                              In all, a total of eleven displays lit up the grounds—each one a celebration of effort, creativity and the sheer joy of movement. Under the warm November sun, the atmosphere was vibrant, colourful and filled with cheers as the young students demonstrated teamwork, coordination and skill. Four of the events in the competitive section—Yoga Drill, Basketball Drill, Aerobics Drill and Resistance Band Drill—were judged to include points for the houses.
                              <br></br>

                              <b>  Day 2: Junior Shikhar (Classes 1-5)</b>
                              <br></br>

                              The second day of Shikhar was dedicated to featuring enthusiastic participation from students of Classes 1 to 5. Day 2 started with a lively march-past by the junior houses, where the little ones marched with charm, pride and coordination.
                              <br></br>

                              The Guest of Honour for the day, Mr G S Shivshankara, a specially abled National level Cricketer, inspired the gathering with his remarkable journey of resilience and hope. He mentioned that he didn’t have everything but made the best of everything. He reiterated that health is a lifelong commitment and there is no age to start working towards it. To honour his spirit, the school management presented Mr G S Shivshankara with a cheque for his unwavering determination, making the celebration even more meaningful. The Academic Achievers of Class 10 Board Examination 2025 and our national Volleyball players for their dedication were recognised by the Guest of Honour and the dignitaries.
                              <br></br>

                              Day 2 of SHIKHAR was a lively celebration of India’s rich cultural and sporting heritage. A Yoga performance opened the day, highlighting mindfulness, discipline and the harmony of body and mind as the perfect prelude to the spirited celebrations. The morning came alive with a powerful display of Kalaripayattu, as young warriors moved with strength, agility and precision to the rhythmic beats of traditional music. Their vibrant costumes swirled with every kick and leap, and the spirited battle cries of the students filled the air, bringing energy, tradition and excitement to the field.
                              <br></br>

                              Alongside this, students brought some of India’s most loved sports—Cricket, Table Tennis, Badminton and Hockey—to life with flawless movements, real sports equipment and enthusiastic commentary that made each game feel thrilling and immersive.
                              <br></br>

                              The day was further brightened by a series of traditional displays, each full of charm and creativity. The Ribbon Drill, the Umbrella Drill and the Bouquet drill were showcased coordination and harmony. The Hula Hoop Drill was playful and energetic, while the Dumbbell Drill combined strength, precision and stamina. Together, these performances blended skill, beauty and joy, creating a memorable and uplifting celebration that left everyone smiling and inspired. There were a total of nine performances.
                              <br></br>

                             <b> A Celebration of Spirit and Inspiration </b>
                              <br></br>

                              The Chief Guest of Day 1 and the Guest of Honour of Day 2 left a lasting impact on students, motivating them to strive for excellence both on and off the field. The two-day event highlighted the school’s commitment to fostering physical fitness, teamwork, inclusivity and character-building through sports. The parents’ response, one of the main stakeholders sums the event SHIKHAR   that ‘the first day was energetic and the second was beautiful’.
                              <br></br>

                              National Public School Yeshwanthpur extends heartfelt gratitude to all students, staff and parents whose support made SHIKHAR 2025 a resounding success.
                              <br></br>
                                </Typography>
                            </Box>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Shikar2025;